import React from 'react';
import { Modal, View, StyleSheet, Text, Pressable, Platform } from 'react-native';
import DLOButton from './DLOButton';

interface DLOExportModalProps {
  visible: boolean;
  onClose: () => void;
  onPrintWithHours: () => void;
  onPrintWithoutHours: () => void;
}

const DLOExportModal: React.FC<DLOExportModalProps> = ({
  visible,
  onClose,
  onPrintWithHours,
  onPrintWithoutHours
}) => {
  return (
    <Modal
      visible={visible}
      onRequestClose={onClose}
      animationType="fade"
      transparent={true}
    >
      <Pressable 
        style={styles.modalOverlay}
        onPress={onClose}
      >
        <Pressable 
          style={styles.modalContainer}
          onPress={(e) => e.stopPropagation()}
        >
          <View style={styles.modalContent}>
            {/* Header */}
            <View style={styles.header}>
              <Text style={styles.title}>Export schedule</Text>
              <Pressable onPress={onClose} style={styles.closeButton}>
                <Text style={styles.closeIcon}>✕</Text>
              </Pressable>
            </View>

            {/* File 1 Option */}
            <View style={styles.fileOption}>
              <View style={styles.fileInfo}>
                <Text style={styles.fileTitle}>File 1</Text>
                <Text style={styles.fileDescription}>Employee hours displayed</Text>
              </View>
              <DLOButton
                text="Print"
                variant="secondary"
                size="medium"
                onPress={onPrintWithHours}
              />
            </View>

            <View style={styles.divider} />

            {/* File 2 Option */}
            <View style={styles.fileOption}>
              <View style={styles.fileInfo}>
                <Text style={styles.fileTitle}>File 2</Text>
                <Text style={styles.fileDescription}>Employee hours Hidden</Text>
              </View>
              <DLOButton
                text="Print"
                variant="secondary"
                size="medium"
                onPress={onPrintWithoutHours}
              />
            </View>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: 561,
    minWidth: 330,
    backgroundColor: '#FFFFFF',
    borderRadius: 24,
    borderWidth: 10,
    borderColor: '#D8E7FB',
    ...Platform.select({
      web: {
        boxShadow: '0px 2px 24px 8px rgba(0, 94, 192, 0.12)',
      },
      default: {
        shadowColor: '#005EC0',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.12,
        shadowRadius: 24,
        elevation: 8,
      },
    }),
  },
  modalContent: {
    padding: 32,
    gap: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingRight: 24,
    gap: 8,
    marginBottom: 12,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 32,
    color: '#2D2D2D',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    flex: 1,
  },
  closeButton: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: {
    fontSize: 20,
    color: '#2D2D2D',
    fontWeight: '400',
  },
  fileOption: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 16,
    paddingVertical: 8,
  },
  fileInfo: {
    flex: 1,
    gap: 4,
  },
  fileTitle: {
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 28,
    color: '#000000',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  fileDescription: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    color: '#4B4B4B',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  divider: {
    height: 1,
    backgroundColor: '#DADADA',
    borderWidth: 1,
    borderColor: '#DADADA',
    marginVertical: 8,
  },
});

export default DLOExportModal;
